import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { HttphelperService } from 'src/app/core/services/helpers/httphelper.service';
import { BreadcrumbService } from 'src/app/core/services/navigation/breadcrumb.service';
import { Item } from 'src/app/models/iscrollable-tabs';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.scss']
})
export class CategoryComponent implements OnInit {
  isLoading:boolean;
  VisitCategories:Item[] = [];
  constructor(private helperService:HttphelperService,public breadSer:BreadcrumbService,
    private router:Router,private cd:ChangeDetectorRef,private messageService: MessageService) { }

  ngOnInit(): void {
    this.breadSer.menuItems = [{ label: "Categories", routerLink: ['category']}];
    this.GetVisitCategories();
  }
  GetVisitCategories()
  {
    this.isLoading = true;
    var visitCategoriesUrl = `/api/Queue/GetVisitCategories`;
    this.helperService.getRequest(visitCategoriesUrl,true).subscribe(response => {
    if(response.Success)
      {
        var result:any = response?.Data;
        if(result == null || result == undefined)
        {
          this.messageService.add({severity: 'warn', summary: 'Warning', detail:response.Message, life: 2000});
        }
        else
        {
          for(var i=0; i<result.length; i++){
            let item:Item;
            item ={
              clinicTypeId : result[i].id,
              clinicId : result[i].clinicId,
              clinicName : "",
              numberofClinic : result[i].numberofClinic,
              mobileDoctorPath : result[i].mobileDoctorPath,
              numberOfSpecialty : result[i].numberOfSpecialty,
              specialtyId : result[i].specialtyId,
              text : result[i].text,
              MobileIconUrl : result[i].MobileIconUrl,
              addtionalData : result[i].addtionalData,
              portalPaymentOption: result[i].portalPaymentOption,
              providerId : null,
              serviceId : null,
              serviceName:"",
              timeSlot:[],
              totalRate:null,
              price:null
            }
            this.VisitCategories.push(item);
          }
        }
      }
      else{
        this.messageService.add({severity: 'error', summary: 'Error', detail:response.Message, life: 2000});
      }   
      this.isLoading = false;
      this.cd.detectChanges();
    },
    error=>{
      this.messageService.add({severity: 'error', summary: 'Error', detail: error, life: 2000});
      this.isLoading = false;
      this.cd.detectChanges();
    })
  }
  getCategoryData(visitCategory:Item)
  {
    this.isLoading = true;
    this.cd.detectChanges();
    this.breadSer.clinicTypeId = visitCategory.clinicTypeId;
    this.breadSer.specialtyId = visitCategory.specialtyId;
    this.breadSer.numberOfSpecialty = visitCategory.numberOfSpecialty;
    this.breadSer.callQueue.MobileDoctorPath = visitCategory.mobileDoctorPath;
    this.breadSer.callQueue.PortalPaymentOption = visitCategory.portalPaymentOption;
    this.breadSer.addtionalData = visitCategory.addtionalData;
    if(visitCategory.numberOfSpecialty == 1)
    {
      var dynamicLabel = "";
      if(this.breadSer.callQueue.MobileDoctorPath == 1 || this.breadSer.callQueue.MobileDoctorPath == 3){
        dynamicLabel = "Doctors";
      }else{
        dynamicLabel = "Clinics";
      }
      this.breadSer.menuItems = [{label: visitCategory.text, routerLink: ['category']},{label: dynamicLabel, routerLink: ['clinicdoctor']}];
      this.router.navigate(['newrequest/clinicdoctor']);
    }
    else
    {
      this.breadSer.menuItems = [{label: visitCategory.text, routerLink: ['category']},{label: "Specialties", routerLink: ['specialty']}];
      this.router.navigate(['newrequest/specialty']);
    }
  }
}
